export default {"src":"/_next/static/media/illustration-steak.a786e1e0.svg","height":87,"width":109};